import axios from "./axios";

export const loginUser = async (username, password) => {

  console.log(process.env.REACT_APP_BACKEND_API_URL)

  const response = await axios.post("/api/users/login/", {username, password})

  return response.data
};

export const refreshToken = async (refresh) => {
  const response = await axios.post("/api/users/token/refresh/", {refresh})

  return response.data
};

export const logoutUser = async (refresh) => {
  const response = await axios.post("/api/users/logout/", {refresh})

  return response.data
}

export const signupUser = async (email, phone, password) => {
  const response = await axios.post("/api/users/signup/", {
    email,
    phone,
    password
  })

  return response.data
}

export const verifyOTP = async (email, phone, otp) => {
  const response = await axios.post("/api/users/verify-otp/", {
    email,
    phone,
    otp
  })

  return response.data
}

export const getEmailOTP = async (email) => {
  const response = await axios.post("/api/users/send-email-otp/", {
    email
  })
  return response.data
}

export const getPhoneOTP = async (phone) => {
  const response = await axios.post("/api/users/send-phone-otp/", {
    phone
  })
  return response.data
}

export const verifyEmailOTP = async (email, otp) => {
  const response = await axios.post("/api/users/verify-email-otp/", {
    email,
    otp
  })
  return response.data
}

export const verifyPhoneOTP = async (phone, otp) => {
  const response = await axios.post("/api/users/verify-phone-otp/", {
    phone,
    otp
  })
  return response.data
}

export const sendForgotPasswordOTP = async (emailOrPhone) => {
  const response = await axios.post("/api/users/forgot-password/send-otp/", {
    email_or_phone: emailOrPhone
  })
  return response.data
}

export const verifyForgotPasswordOTP = async (emailOrPhone, otp) => {
  const response = await axios.post("/api/users/forgot-password/verify-otp/", {
    email_or_phone: emailOrPhone,
    otp
  })
  return response.data
}

export const resetPassword = async (emailOrPhone, otp, newPassword) => {
  const response = await axios.post("/api/users/forgot-password/reset/", {
    email_or_phone: emailOrPhone,
    otp,
    new_password: newPassword
  })
  return response.data
}